
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}
var $d3d1226a2e0e9cd0$exports = {};
$d3d1226a2e0e9cd0$exports = JSON.parse("{\"id\":\"1\",\"name\":\"Main Menu\",\"slug\":\"main-menu\",\"menu-items\":[{\"name\":\"Video Sync\",\"url\":\"/\",\"sub-menu\":false},{\"name\":\"Pattern Mode\",\"url\":\"/patterns\",\"sub-menu\":false},{\"name\":\"Help\",\"url\":\"/help\",\"sub-menu\":false}]}");


document.addEventListener('DOMContentLoaded', ()=>{
    const mainMenuContainer = document.querySelector('#main_menu');
    if (mainMenuContainer) $6103494133518c73$var$RenderMenu((0, (/*@__PURE__*/$parcel$interopDefault($d3d1226a2e0e9cd0$exports))), mainMenuContainer);
    const mobileMenuContainer = document.querySelector('#mobile_menu_container');
    if (mobileMenuContainer) $6103494133518c73$var$RenderMenu((0, (/*@__PURE__*/$parcel$interopDefault($d3d1226a2e0e9cd0$exports))), mobileMenuContainer);
    // mobile menu
    const hamburger = document.querySelector('#mobile_hamburger');
    const mobileMenu = document.querySelector('#mobile_menu');
    if (hamburger && mobileMenu) {
        const mobileMenuClose = mobileMenu.querySelector('.ico--close');
        hamburger.addEventListener('click', (e)=>{
            mobileMenu.classList.add('active');
        });
        if (mobileMenuClose) mobileMenuClose.addEventListener('click', (e)=>{
            mobileMenu.classList.remove('active');
        });
    }
});
const $6103494133518c73$var$RenderMenu = (menu, location)=>{
    if (location instanceof HTMLUListElement) {
        const menuItems = menu['menu-items'];
        if (!menuItems || !Array.isArray(menuItems)) {
            console.error('Invalid menu data:', menu);
            return;
        }
        const currentUrl = window.location.pathname; // Get current page URL path
        menuItems.forEach((item)=>{
            const menuItem = document.createElement('li');
            menuItem.classList.add('menu-item');
            // Check if this menu item's URL matches the current page
            const isActive = currentUrl === item.url ? 'active' : '';
            menuItem.innerHTML = `<a href="${item.url}" class="${isActive}">${item.name}</a>`;
            location.appendChild(menuItem);
        });
    }
};


//# sourceMappingURL=index.bcc0fe4e.js.map
